import {defineMessages} from 'react-intl';

export default defineMessages({
	results: {
		id: 'plp.search.searchResultText',
		defaultMessage: 'results for',
	},
	noResults: {
		id:'plp.search.noResultsText',
		defaultMessage:'We didn’t find any items corresponding exactly to your query.'
	},
	backToShopButton: {
		id:'plp.search.backToShopButton',
		defaultMessage: 'Back to shopping'
	}
});
